// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  currentEnv: 'development',
  api: 'https://api.lifestyle-check.staging.maviework.care',
  teleapp: 'https://tele.lifestyle-check.staging.maviework.care',
  app: 'https://app.wellabe.dev/',
  rollbar: {
    accessToken: '81b7012cf50c411fb3d4de4866a4e904',
    payload: {
      environment: 'dev',
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: '1.0.0',
          guess_uncaught_frames: true,
        },
      },
    },
    enabled: true,
  },
  analytics: {
    trackerUrl: 'https://track.wellabe.fit/',
    siteId: '5',
    subdomain: '*.doc.wellabe.dev',
  },
  cookie: {
    privacy_link: 'https://web.wellabe.fit/terms/policy-terms',
  },
  appointments: {
    supportPagination: false,
  },
};
